import Modal from "modal-react-native-web"
import React, { useState } from "react"
import { Platform, StyleSheet, TouchableOpacity, View } from "react-native"
import { Overlay } from "react-native-elements"
import Icon from "react-native-vector-icons/AntDesign"
import { useDispatch, useSelector } from "react-redux"

import Base, { Actions, Api } from "../../../../base"
import { Alert, LoadingView } from "../../../common"
import MenuView from "./MenuView"

function menuHeader(navigation) {
  return {
    ...Base.constants.headerOptions(false, "Menu Stock"),
    headerLeft: () => (
      <TouchableOpacity
        style={Base.styles.headerButton}
        onPress={() => navigation.goBack()}
      >
        <Icon name="arrowleft" size={24} color="white" />
      </TouchableOpacity>
    ),
  }
}

export default function MenuScreen(props) {
  const service = useSelector(state => state.service)
  props.navigation.setOptions(menuHeader(props.navigation))
  const [loading, setLoading] = useState(null)
  const dispatch = useDispatch()

  const isFlooid = service?.menu?.provider === "Flooid"
  async function onStatusChange(item, status) {
    try {
      setLoading("Updating Status...")

      const success = await Api.updateMenuStatus(item, status)
      if (!success || success === null) {
        Alert.show(
          "Hold Up!",
          "Unable to update this item at the moment, please check your connection and try again.",
          "OK",
          () => {
            setLoading(null)
          },
        )
        return
      }

      const key =
        item.__type === "MenuItem"
          ? isFlooid
            ? "active"
            : "isActive"
          : "enabled"
      const menu = Base.functions.toggleItemValue(
        { ...service.menu },
        item._id,
        key,
        status,
      )
      dispatch(Actions.setService({ ...service, menu }))
      setLoading(null)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <View style={styles.main}>
      <MenuView menu={service?.menu} onStatusChange={onStatusChange} />
      {Platform.OS === "web" ? (
        <Modal animationType="fade" transparent={true} visible={!!loading}>
          <LoadingView title={loading} />
        </Modal>
      ) : (
        <Overlay
          isVisible={!!loading}
          windowBackgroundColor="#00000097"
          overlayStyle={styles.overlay}
          animationType={"fade"}
          statusBarTranslucent={"true"}
        >
          <LoadingView title={loading} />
        </Overlay>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
    backgroundColor: Base.colours.appLightGrey,
  },
  overlay: {
    backgroundColor: "transparent",
    shadowOpacity: 0,
    elevation: 0,
  },
})
